/*Состояния*/
const state = () => ({
  connected: navigator.onLine,
});
export { state };
